import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, List, Button, Modal, InputItem, Toast, ActionSheet } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/Team.css';
import iconAvatar from '../medias/avatar.svg';

const history = require("history").createHashHistory()
const alert = Modal.alert

class Team extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            agentProfile: {
                profitPoint: 0,
                maxSites: 0
            },
            showCreateModal: false,
            enableCreate: true,
            showUpdateModal: false,
            enableUpdate: true,
            selectedItem: null,
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 80;
        this.setState({
            height
        })
        this.loadProfile()
        this.loadData(1)
    }

    loadProfile = () => {
        DataFetcher.agentProfile({
            success: (resp) => {
                this.setState({
                    agentProfile: resp.data
                })
            }
        })
    }

    loadData = (pageNum) => {
        DataFetcher.pageTeamMember({
            pageNum,
            pageSize: 10
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadData(++this.pageNum)
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    handleItemClick = (rowData) => {
        const options = [
            { icon: <i className='iconfont icon-xiugai' style={{color:'#04bbc5', fontSize: 30}}/>, title: '编辑信息' },
            { icon: <i className='iconfont icon-tubiaozhexiantu' style={{color: 'gold', fontSize: 30}}/>, title: '团队数据' }
        ]
        if(rowData.userId) {
            options.push({ icon: <i className='iconfont icon-jiechudiyadengji' style={{color:'orange', fontSize: 30}}/>, title: '解除绑定' })
        }
        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.agentName,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '编辑信息') {
                this.setState({
                    showUpdateModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '团队数据') {
                history.push(`/team/statistic/${rowData.agentId}`)
            } else if(buttonTitle === '解除绑定') {
                this.handleUnbindClick(rowData)
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleCreateClick = () => {
        this.setState({
            enableCreate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('create_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableCreate: true
                        })
                        return
                    }
                }
            }
            const params = {
                agentName: fieldsValue.create_agentName,
                profitPoint: fieldsValue.create_profitPoint,
                maxSites: fieldsValue.create_maxSites
            }
            DataFetcher.createTeamMember(params, {
                success: (resp) => {
                    this.setState({
                        showCreateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadData(1)
                },
                completed: () => {
                    this.setState({
                        enableCreate: true
                    })
                }
            })
        });
    }

    handleUpdateClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableUpdate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('update_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdate: true
                        })
                        return
                    }
                }
            }

            const params = {
                id: selectedItem.agentId,
                agentName: fieldsValue.update_agentName,
                profitPoint: fieldsValue.update_profitPoint,
                maxSites: fieldsValue.update_maxSites
            }
            DataFetcher.updateTeamMember(params, {
                success: (resp) => {
                    this.setState({
                        showUpdateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadData(1)
                },
                completed: () => {
                    this.setState({
                        enableUpdate: true
                    })
                }
            })
        });
    }

    handleUnbindClick = (rowData) => {
        if(!rowData) return

        alert('确认要解除绑定?', rowData.agentName, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                DataFetcher.unbindTeamMember({
                    id: rowData.agentId
                }, {
                    success: (resp) => {
                        Toast.info('已解除绑定')
                        this.loadData(1)
                    }
                })
            }},
          ])
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>&nbsp;{rowData.agentName}</span>}
                            thumb={<img src={rowData.avatar?rowData.avatar:iconAvatar} alt='avatar'/>}
                            extra={<div><span className='value'>{rowData.userId?'':'待邀请'}</span></div>}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>分成比例：</span> 
                                    <span className='value'>{rowData.profitPoint}%</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>门店上限：</span> 
                                    <span className='value'>{rowData.maxSites}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>微信昵称：</span> 
                                    <span className='value'>{rowData.nickName}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>手机号码：</span> 
                                    <span className='value'>{rowData.mobile}</span>
                                </div>
                            </div>
                            <div className={`info-row${rowData.userId?' hide':''}`} style={{fontSize: 14, marginTop: 15}}>
                                <span style={{color:'gray'}}>通知用户在公众号发送邀请码&nbsp;&nbsp;</span>
                                <span style={{color:'#04bbc5'}}>{rowData.verifyCode}</span>
                            </div>
                        </Card.Body>
                        <Card.Footer extra={<span>{rowData.createTime}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderCreateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showCreateModal, enableCreate, agentProfile } = this.state
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showCreateModal}
                    onClose={() => {
                        this.setState({showCreateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>邀请成员</div>}>
                        <InputItem {...getFieldProps('create_agentName', {
                            initialValue: '',
                            rules: [{required: true, message: '请填写成员姓名'}],
                        })}>
                            成员姓名
                        </InputItem>
                        <InputItem type='number' extra='%' placeholder={`不超过${agentProfile.profitPoint}`} {...getFieldProps('create_profitPoint', {
                            initialValue: '',
                            rules: [{required: true, message: '请填写分成比例'}],
                        })}>
                            分成比例
                        </InputItem>
                        <InputItem type='number' {...getFieldProps('create_maxSites', {
                            initialValue: 1,
                            rules: [{required: true, message: '请填写门店上限'}],
                        })}>
                            门店上限
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleCreateClick} disabled={!enableCreate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderUpdateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showUpdateModal, enableUpdate, agentProfile, selectedItem } = this.state
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateModal}
                    onClose={() => {
                        this.setState({showUpdateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>编辑信息</div>}>
                        <InputItem {...getFieldProps('update_agentName', {
                            initialValue: selectedItem?selectedItem.agentName:null,
                            rules: [{required: true, message: '请填写成员姓名'}],
                        })}>
                            成员姓名
                        </InputItem>
                        <InputItem type='number' extra='%' placeholder={`不超过${agentProfile.profitPoint}`} {...getFieldProps('update_profitPoint', {
                            initialValue: selectedItem?selectedItem.profitPoint:null,
                            rules: [{required: true, message: '请填写分成比例'}],
                        })}>
                            分成比例
                        </InputItem>
                        <InputItem type='number' {...getFieldProps('update_maxSites', {
                            initialValue: selectedItem?selectedItem.maxSites:null,
                            rules: [{required: true, message: '请填写门店上限'}],
                        })}>
                            门店上限
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateClick} disabled={!enableUpdate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    render() {
        const {dataSource, isLoading} = this.state;
        return (
            <div className='page-team'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={<i className='iconfont icon-tianjia' style={{color:'black'}} onClick={() => {this.setState({showCreateModal: true})}}></i>}
                >
                    我的团队
                </NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
                {this.doRenderCreateModal()}
                {this.doRenderUpdateModal()}
            </div>
        )
    }
}

export default createForm()(Team);


// WEBPACK FOOTER //
// ./src/modules/Team.js